import { DetailForm } from '@/@diffrag/form/DetailForm'
import { FormFieldType } from '@/@diffrag/form/fields/type'
import { useApi } from '@/@diffrag/hooks/useApi'
import { useQueryValue } from '@/@diffrag/hooks/useQueryValue'
import { ContentDetailView } from '@/@diffrag/layout/ContentDetailView'
import { api } from '@/api'
import { toast } from '@/lib/toast'
import { IAdminRegionSave, IRegionROO2 } from 'api'
import { useNavigate } from 'react-router-dom'

export default function RegionEdit() {
  const navigate = useNavigate()
  const id = useQueryValue('id', '')

  const { data, refetch } = useApi({
    id: 'regionDetail',
    fn: api().adminRegion.adminRegionDetail,
    params: Number(id),
    enabled: !!id,
  })

  const onSave = async (data: IRegionROO2) => {
    const saveData: IAdminRegionSave = {
      name: data.name,
      order: data.order,
    }

    try {
      await api().adminRegion.adminRegionCreate(saveData)
    } catch (error) {
      toast.error('중복된 지역명입니다.')
    }
    refetch()
  }

  const onDelete = async () => {
    if (id) {
      await api().adminRegion.adminRegionDelete(Number(id))
    }
  }

  return (
    <ContentDetailView
      title="지역 수정"
      data={data}
      onSave={onSave}
      onDelete={onDelete}
    >
      <DetailForm
        data={data}
        fields={[
          {
            label: '지역명',
            key: 'name',
            type: FormFieldType.STRING,
            required: true,
          },
          {
            label: '순서',
            key: 'order',
            type: FormFieldType.NUMBER,
            required: true,
          },
        ]}
      />
    </ContentDetailView>
  )
}
